import { render } from "./StoreClaimInvoices.vue?vue&type=template&id=10f494a6"
import script from "./StoreClaimInvoices.vue?vue&type=script&lang=js"
export * from "./StoreClaimInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__